import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Label } from "@/components/ui/label";

export const inputCls =
  "w-full bg-transparent border-0 border-b border-foreground/25 rounded-none px-0 py-3 text-lg " +
  "text-foreground placeholder:text-foreground/35 focus:outline-none focus:border-primary " +
  "transition-colors duration-300";

export const Field = ({ label, htmlFor, children, className = "" }) => (
  <div className={`flex flex-col gap-2 ${className}`}>
    <Label htmlFor={htmlFor} className="text-xs uppercase tracking-[0.18em] text-foreground/55">
      {label}
    </Label>
    {children}
  </div>
);

export function useLeadSubmit(leadType) {
  const [submitting, setSubmitting] = useState(false);

  const submit = async (payload, onDone) => {
    setSubmitting(true);
    // Drop empty strings so optional fields don't fail backend validation
    const clean = Object.fromEntries(
      Object.entries(payload).filter(([, v]) => v !== "" && v != null)
    );
    try {
      const { data } = await api.post("/leads", { lead_type: leadType, ...clean });
      toast.success(data.message || "Thanks! We'll be in touch soon.");
      onDone?.();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Something went wrong.");
    } finally {
      setSubmitting(false);
    }
  };

  return { submit, submitting };
}
